import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchAnnonces, fetchMyFavorites } from "@/lib/api";
import { getFavorites } from "@/lib/utils";
import { useAuth } from "@/lib/AuthContext";
import AnnonceCard from "@/components/AnnonceCard";
import { Heart } from "lucide-react";

export default function FavorisPage() {
  const { user, loading: authLoading } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    setLoading(true);
    if (user) {
      fetchMyFavorites().then(setItems).finally(() => setLoading(false));
    } else {
      const favIds = getFavorites();
      if (favIds.length === 0) { setItems([]); setLoading(false); return; }
      fetchAnnonces({ page_size: 48 }).then((d) => {
        setItems((d.items || d).filter((a) => favIds.includes(a.id)));
      }).finally(() => setLoading(false));
    }
  }, [user, authLoading]);

  return (
    <main className="max-w-7xl mx-auto px-6 py-10" data-testid="favoris-page">
      <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight">Mes favoris</h1>
      <p className="text-[var(--ink-soft)] mt-2">
        {user ? "Synchronises sur votre compte Fodindin." : "Sauvegardes sur ce navigateur (connectez-vous pour les synchroniser)."}
      </p>

      {loading ? (
        <div className="glass-card p-10 mt-10 text-center">Chargement...</div>
      ) : items.length === 0 ? (
        <div className="glass-card p-12 mt-10 text-center" data-testid="favoris-empty">
          <Heart size={36} className="mx-auto text-orange-500 mb-3" />
          <div className="font-bold text-lg mb-2">Aucun favori pour l'instant</div>
          <p className="text-sm text-[var(--ink-soft)] mb-5">Parcourez les annonces et cliquez sur le coeur pour les ajouter ici.</p>
          <Link to="/annonces" className="btn-primary">Voir les annonces</Link>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {items.map((a) => <AnnonceCard key={a.id} a={a} />)}
        </div>
      )}
    </main>
  );
}
